import React, { Component } from 'react';
import Redirect from 'react-router-dom/Redirect';
import { Auth, Customer } from '../../../../services/api';
import TokenStorage from '../../../../services/TokenStorage';
import Storage from '../../../../services/Storage';
import { Form } from 'antd';
import LoginForm from './Form';

const WrappedForm = Form.create()(LoginForm)

export default class Login extends Component {
    constructor(props) {
        super(props);

        this.authApi = new Auth();
        this.customerApi = new Customer(props);
        const query = new URLSearchParams(this.props.location.search);

        this.state = {
            redirectToReferer: false,
            loginFailed: false,
            loading: false,
            email: query.get('email') !== null ? query.get('email').replace(' ', '+') : ''
        };
    }

    login = (username, password) => {
        this.setState({ loading: true });
        this.authApi.login(username, password)
            .then(res => {
                TokenStorage.setToken(TokenStorage.TYPE_ID, res.data.data.id_token);
                TokenStorage.setToken(TokenStorage.TYPE_REFRESH, res.data.data.refresh_token);
                this.fetchMe();
            })
            .catch(_ => { 
                this.setState({ loginFailed: true, loading: false });
            })
    };

    fetchMe = () => {
        this.authApi.me()
            .then(res => {
                Storage.set('CUSTOMER', res.data.data.name);
                this.setState({ redirectToReferer: true, loading: false });
            })
            .catch(_ => {
                this.authApi.retry({ cb: this.fetchMe, loading: false });
            });
    }

    render() {
        let { from } = this.props.location.state || { from: { pathname: '/menus' } };
        const { redirectToReferer, loginFailed, loading, email  } = this.state;

        if (redirectToReferer === true) {
            if (!from) {
                from = { from: { pathname: '/menus' } };
            }
            return <Redirect to={from} />
        }

        return (
            <WrappedForm loading={loading} email={email} loginFailed={loginFailed} submitHandler={this.login} />
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/auth/components/login/Login.js